import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SectionHeading from '../../../components/ui/SectionHeading';
import Button from '../../../components/ui/Button';
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';

const contactItems = [
  {
    title: 'Par téléphone',
    icon: PhoneIcon,
    details: [
      { label: 'Maternelle', value: '05 22 89 52 24' },
      { label: 'Primaire', value: '05 22 90 82 38' },
      { label: 'Collège', value: '05 22 89 52 40' },
      { label: 'Lycée', value: '05 22 93 04 08' },
    ],
  },
  {
    title: 'Par email',
    icon: EnvelopeIcon,
    details: [
      { label: 'Maternelle', value: 'maternelle@gssanaa.com' },
      { label: 'Primaire', value: 'primaire@gssanaa.com' },
      { label: 'Collège', value: 'college@gssanaa.com' },
      { label: 'Lycée', value: 'lycee@gssanaa.com' },
    ],
  },
  {
    title: 'Nos adresses',
    icon: MapPinIcon,
    details: [
      { label: 'Maternelle', value: 'N°55, Rue 27, Oulfa, Casablanca' },
      { label: 'Primaire', value: '362 Bd Ouad Oum Rabii, Oulfa' },
      { label: 'Collège', value: 'N°31, Rue 27, Oulfa, Casablanca' },
      { label: 'Lycée', value: 'N°5 et 7, Angle Rue 49 et 50 Groupe "U", Oulfa, Casablanca' },
    ],
  },
];

const ContactSection = () => {
  return (
    <div className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Contactez-nous"
          subtitle="Prenez contact"
          centered={true}
        />

        <motion.div 
          className="max-w-4xl mx-auto mt-12 grid md:grid-cols-3 gap-8"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {contactItems.map((item, index) => (
            <div 
              key={item.title}
              className="bg-white rounded-lg p-6 shadow-elegant"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <item.icon className="h-6 w-6 text-primary" />
                </div>
                <h3 className="ml-3 text-lg font-semibold">{item.title}</h3>
              </div>
              
              <ul className="space-y-2">
                {item.details.map((detail) => (
                  <li key={detail.label} className="flex flex-col">
                    <span className="text-sm text-gray-500">{detail.label}</span>
                    <span className="font-medium text-gray-800">{detail.value}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </motion.div>

        <div className="mt-12 text-center">
          <p className="text-lg text-gray-700 mb-6">
            Vous souhaitez en savoir plus sur nos programmes ou visiter notre établissement ?
          </p>
          <Button to="/contact" variant="primary" size="large">
            Page de contact complète
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;